import mitt from 'mitt';
// Used to allow API clients to register for auth session ID change events.
export const apiEventsEmitter = mitt();
//# sourceMappingURL=events.js.map